// 路由配置
import Vue from 'vue'
import VueRouter from 'vue-router'
import _ from 'underscore'
import { LoadingBar } from 'view-design'
import { KEEP_ALIVE_VIEWS } from './constants'

// store
import store from '../store/index'

// 登录页
import Login from '../views/Login.vue'

// 通用页
import NotFound from '../components/layout/NotFound.vue'
import Forbidden from '../components/layout/Forbidden.vue'
import ServerError from '../components/layout/ServerError.vue'

// 路由失败
const errorRouter = [{
  path: '*',
  redirect: 'notFound'
}]
store.commit('updateErrorRouter', errorRouter)

Vue.use(VueRouter)

const router = new VueRouter({
  // mode: 'history',
  routes: [{
    path: '/login',
    name: 'login',
    component: Login
  }, {
    path: '/notFound',
    name: 'notFound',
    component: NotFound
  }, {
    path: '/forbidden',
    name: 'forbidden',
    component: Forbidden
  }, {
    path: '/serverError',
    name: 'serverError',
    component: ServerError
  }]
})

// keepAlive views path
const keepAliveViews = KEEP_ALIVE_VIEWS

router.beforeEach((to, from, next) => {
  LoadingBar.start()
  if (store.state.token && to.path === '/login') {
    next('/')
    LoadingBar.finish()
  } else if (store.state.verify && !store.state.token && to.path !== '/login') {
    next('/login')
    LoadingBar.finish()
  } else {
    if (_.indexOf(keepAliveViews, to.path) !== -1) {
      to.meta.keepAlive = true
    }
    next()
  }
})

router.afterEach((to, from) => {
  const toMatched = to.matched && to.matched[1]
  if (toMatched) {
    store.commit('updateCurrentPath', toMatched.path)
  }
  const errorPath = ['/notFound', '/forbidden', '/serverError']
  if (_.indexOf(errorPath, to.path) !== -1) {
    LoadingBar.error()
  } else {
    LoadingBar.finish()
  }
  window.scrollTo(0, 0)
})

export default router
